import React from "react";

const QuranRecitationPopupPanel = ({
  uiLabels,
  contentPopup,
  recitationMode,
  onChangeRecitationMode,
  recitationReaderMenuRef,
  recitationReaderMenuSuppressUntilRef,
  recitationOptionsLoading,
  recitationResources,
  recitationReaderMenuOpen,
  setRecitationReaderMenuOpen,
  recitationResourceId,
  onChangeRecitationReader,
  truncateLabel,
  onStartRecitationFromPopup,
}) => (
  <>
    <div className="quran-translation-controls">
      <label className="quran-translation-control">
        <span>{uiLabels.mode}</span>
        <div className="quran-recitation-mode-toggle" role="group" aria-label={uiLabels.mode}>
          <button
            type="button"
            className={`quran-recitation-mode-btn ${
              recitationMode === "ayah" ? "quran-recitation-mode-btn--active" : ""
            }`}
            onClick={() => onChangeRecitationMode("ayah")}
            disabled={contentPopup.loading}
          >
            {uiLabels.thisVerse}
          </button>
          <button
            type="button"
            className={`quran-recitation-mode-btn ${
              recitationMode === "chapter" ? "quran-recitation-mode-btn--active" : ""
            }`}
            onClick={() => onChangeRecitationMode("chapter")}
            disabled={contentPopup.loading}
          >
            {uiLabels.untilEndSurah}
          </button>
        </div>
      </label>

      <label className="quran-translation-control">
        <span>{uiLabels.reader}</span>
        <div className="quran-book-select" ref={recitationReaderMenuRef}>
          <button
            type="button"
            className="quran-book-trigger"
            onClick={(event) => {
              event.stopPropagation();
              if (Date.now() < recitationReaderMenuSuppressUntilRef.current) {
                return;
              }
              setRecitationReaderMenuOpen((prev) => !prev);
            }}
            disabled={recitationOptionsLoading || recitationResources.length === 0}
            aria-expanded={recitationReaderMenuOpen}
          >
            <span>
              {truncateLabel(
                (() => {
                  const selected = recitationResources.find((resource) => resource.id === recitationResourceId);
                  if (!selected) {
                    return recitationResources.length === 0 ? uiLabels.noReader : uiLabels.chooseReaderShort;
                  }

                  return [selected.displayName, selected.style].filter(Boolean).join(" - ");
                })(),
                34
              )}
            </span>
            <span className="quran-book-caret">▾</span>
          </button>

          {recitationReaderMenuOpen && recitationResources.length > 0 && (
            <div className="quran-book-menu" role="listbox" onClick={(event) => event.stopPropagation()}>
              {recitationResources.map((resource) => (
                <button
                  type="button"
                  key={`reader-${resource.id}`}
                  className={`quran-book-option ${
                    resource.id === recitationResourceId ? "quran-book-option--active" : ""
                  }`}
                  onClick={(event) => {
                    event.stopPropagation();
                    onChangeRecitationReader(resource.id);
                  }}
                  title={[resource.displayName, resource.style].filter(Boolean).join(" - ")}
                >
                  {truncateLabel(
                    [resource.displayName, resource.style].filter(Boolean).join(" - ") || `Lecteur ${resource.id}`,
                    36
                  )}
                </button>
              ))}
            </div>
          )}
        </div>
      </label>
    </div>

    <div className="quran-translation-actions">
      <button type="button" className="quran-context-btn" onClick={onStartRecitationFromPopup}>
        {uiLabels.startPlayback}
      </button>
    </div>
  </>
);

export default QuranRecitationPopupPanel;